import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation } from 'react-i18next';
import BatteryChargingIcon from '../../assets/icons/battery_charging.svg';
import { ColorType } from '../../assets/colors/colors.g';

const useStyles = makeStyles(() => ({
  banner: {
    position: 'fixed',
    bottom: 0,
    maxWidth: '425px',
    backgroundColor: '#EBF8FF',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'flex-start',
    cursor: 'pointer',
    boxSizing: 'border-box',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'flex-start', // Changed from invalid 'top' to 'flex-start'
    marginRight: '12px',
  },
  batteryIcon: {
    marginTop: '2px',
    width: '20px',
    height: '20px',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
  },
  heading: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    color: ColorType.BRAND3,
    marginBottom: '4px',
  },
  message: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
  },
  chargerName: {
    fontWeight: 600,
  },
  chevron: {
    color: '#4E5968',
    marginLeft: '12px',
    flexDirection: 'column',
    alignItems: 'flex-start', // Center the chevron vertically
  },
}));

interface ActiveSessionBannerProps {
  chargerName: string;
  onNavigate: () => void;
}

const ActiveSessionBanner: React.FC<ActiveSessionBannerProps> = ({ chargerName, onNavigate }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.banner} onClick={onNavigate}>
      <Box className={classes.iconContainer}>
        <img src={BatteryChargingIcon} alt='Battery charging' className={classes.batteryIcon} />
      </Box>
      <Box className={classes.content}>
        <Typography className={classes.heading}>{t('active_session')}</Typography>
        <Typography className={classes.message}>
          <>
            {t('active_session_message_part1')}{' '}
            <span className={classes.chargerName}>{chargerName}</span>.{' '}
            {t('active_session_message_part2')}
          </>
        </Typography>
      </Box>
      <ChevronRightIcon className={classes.chevron} />
    </Box>
  );
};

export default ActiveSessionBanner;
